module.exports = __webpack_public_path__ + "static/ev-re320_1600.b96676db.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/photos/ev-re320_1600.jpg
// module id = 616
// module chunks = 0